import { Page, PageTitle } from "@/components/page"
import { AlarmClock, BrainIcon, Plus, Sparkles } from "lucide-react"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { DataTable } from "@/components/datatable/datatable"
import { useTeamStore } from "@/lib/hooks/useTeam"
import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"
import { useCallback } from "react"
import { usePermissions } from "@/lib/hooks/usePermissions"

const typeOptions = {
  0: "Hourly",
  1: "Daily",
  2: "Monthly",
}

export const jobs = {
  title: "Jobs",
  description: "Manage your scheduled jobs and their configurations.",
  route: "/jobs",
  url: "/jobs",
  group: "settings",

  icon: AlarmClock,
  component,
  resource: "jobs",
  action: "read",
} satisfies PageConfig

const columns: Columns<Table<"jobs">> = {
  title: { header: "Title", size: 500 },
  team: { header: "Team", size: 200, cell: ({ row }) => row.original.team?.["name"] },
  agent: { header: "Agent", size: 200, cell: ({ row }) => row.original.agent?.["title"] },
  type: { header: "Type", size: 200, cell: ({ row }) => typeOptions[row.original.type] || "Unknown" },
  // range: { header: "Range", size: 200, cell: ({ row }) => row.original.range },
  // fri: boolean | null
  // mon: boolean | null
  // sat: boolean | null
  // sun: boolean | null
  // thu: boolean | null
  // tue: boolean | null
  // wed: boolean | null
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {

  const { selectedTeam } = useTeamStore()
  const navigate = useNavigate()
  const { canCreate } = usePermissions()
  const filter = useCallback(q => q.eq("team", selectedTeam?.id), [selectedTeam])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("jobs") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/job/new')} ><Plus className="h-4 w-4" />Create Job</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="jobs"
        columns={columns}
        showSelection
        onRowClick={"/job"}
        sort={["created_at", "desc"]}
        filter={filter}
        select={`
        *,
        team (
          name
        ),
        agent (
          title
        )
      `}
        enableServerSideFiltering={true}
        searchableColumns={["title"]}
      />
    </div>
  </Page>

}

